import {mmap} from '@freckle/maybe'
import {identityProvidersWithCount} from '@freckle/educator-entities/ts/roster/identity-provider'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {SummaryT} from '@freckle/school/ts/common/models/summary'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import SyncBar from './sync-bar/index'
import {rosteringBar, wrapper} from './rostering-bar.module.scss'

type Props = {
  summary: SummaryT
  hasActiveIdp: boolean
}

export default function RosteringBar(props: Props) {
  const {summary, hasActiveIdp} = props
  const {t} = useSafeTranslation()

  const anyManagedStudents = identityProvidersWithCount(summary.studentCounts).length > 0
  const showRosterCleanup = hasActiveIdp || anyManagedStudents

  return (
    <div className={rosteringBar}>
      {mmap(
        e => (
          <SyncBar mostRecentRosterSyncEvent={e} />
        ),
        summary.mostRecentRosterSyncEvent,
      )}
      <div className={wrapper}>
        <Link
          style="btn-primary"
          href={Routes.rostering.importRoster()}
          dataTest="dashboard-rostering-import-btn"
          reactRouter
        >
          {t('MANAGE_TEACHERS_ROSTERING_BAR_IMPORT_ROSTER_BUTTON')}
        </Link>
        {showRosterCleanup ? (
          <Link
            style="btn-secondary"
            href={Routes.rostering.cleanUpRoster()}
            dataTest="dashboard-rostering-clean-up-btn"
            reactRouter
          >
            {t('MANAGE_TEACHERS_ROSTERING_BAR_CLEAN_UP_ROSTER_BUTTON')}
          </Link>
        ) : null}
      </div>
    </div>
  )
}
